{
  "acceptedFileFormats": "Zaakceptowane są tylko pliki .docx, .pdf, .txt.",
  "actionCompetenceGroup": "Grupa Kompetencji Działania",
  "actionDeadline": "Termin Działania",
  "actionDescription": "Opis Działania",
  "actionDuration": "Czas Trwania Działania",
  "actionEarliestStart": "Najwcześniejszy Start Działania",
  "actionName": "Nazwa Działania",
  "actions": "Działania",
  "actionsAndProjects": "Działania i Projekty",
  "actionsColon": "Działania: ",
  "actionsPerformerConstraints": "Ograniczenia Wykonawcy Działań",
  "add": "Dodaj",
  "addAdmin": "Dodaj Administratora",
  "addAdminTitle": "Dodaj Administratora",
  "addAnalyses": "Dodaj analizy",
  "addAnalysis": "Dodaj Analizę",
  "addAnalysisGroup": "Dodaj grupę analiz",
  "addChatbot": "Dodaj chatbota",
  "addCompetenceGroup": "Dodaj Grupę Kompetencji",
  "addConstraint": "Dodaj ograniczenie",
  "addGreyTask": "Dodaj GreyTask",
  "addInstrument": "Dodaj instrument",
  "addItemPlaceholder": "Dodaj {{item}}...",
  "addLocation": "Dodaj lokalizację",
  "addMaintenance": "Dodaj konserwację",
  "addMember": "Dodaj członka",
  "addNewBundle": "Dodaj Nowy Pakiet",
  "addNewMaintenanceFor": "Dodaj nową konserwację dla {{assetName}}",
  "addNewTask": "Dodaj nowe zadanie",
  "addOffsite": "Dodaj OFFSITE",
  "addProjectGroup": "Dodaj grupę projektów",
  "addProjectTemplate": "Dodaj Szablon Projektu",
  "addRepository": "Dodaj repozytorium",
  "addRow": "Dodaj Wiersz",
  "addSample": "Dodaj próbkę",
  "addSamples": "Dodaj próbki",
  "addTeam": "Dodaj zespół",
  "additionalInformation": "Informacje Dodatkowe",
  "administrators": "Administratorzy",
  "advanced": "Zaawansowane",
  "allFilesProcessed": "Wszystkie przesłane pliki zostały przetworzone",
  "allowMembersMoveOthersOperationalTasks": "Zezwól członkom na przenoszenie zadań operacyjnych innych osób",
  "allowedCompetenceGroups": "Dopuszczalne Grupy Kompetencji",
  "allowedInstruments": "Dozwolone instrumenty",
  "amountOfSamples": "Liczba próbek: {{count}}",
  "analyses": "Analizy",
  "analysesRelatedTo": "Analizy dotyczące {{product}}",
  "analysis": "Analiza",
  "analysisAndSampleDone": "Analiza i próbka są zakończone",
  "analysisDefinition": "definicja analizy",
  "analysisDesignTool": "Narzędzie Projektowania Analiz",
  "analysisDone": "Analiza jest zakończona",
  "analysisDraft": "Analiza WERSJA ROBOCZA",
  "analysisGroup": "Grupa analiz",
  "analysisGroupName": "Nazwa Grupy Analiz",
  "analysisIsFlagged": "Analiza jest oznaczona flagą",
  "analysisMustContainTaskDefinition": "Analiza musi zawierać definicję zadania",
  "analysisName": "Nazwa Analizy",
  "analysisNameMustBeUnique": "Nazwa Analizy musi być unikalna",
  "analysisNotPlanned": "Ta analiza nie jest zaplanowana",
  "analysisPlanned": "Analiza jest zaplanowana",
  "analysisTaskBundle": "Pakiet Zadań Analizy {{index}}",
  "cdmoTargetedBundle": "Grupuj zadania według nazwy analizy",
  "analysisTaskTimePerformerSamples": "Zadanie Analizy - Czas, Wykonawca, Liczba Próbek",
  "analysisTasks": "zadania analizy",
  "analysisTasksToBundle": "Zadania Analizy do Pakietu",
  "analysisTimePercentage": "Procent czasu analizy w stosunku do czasu całkowitego (A2T)",
  "anywhere": "Gdziekolwiek",
  "apiToken": "Token API",
  "archiveMember": "Archiwizuj Członka",
  "archived": "zarchiwizowane",
  "areYouSureConnection": "Czy na pewno chcesz mieć to połączenie?",
  "areYouSureConnectionMode": "Czy na pewno chcesz przejść w tryb \"z połączeniem\"? Spowoduje to usunięcie wszystkich bieżących połączeń",
  "areYouSureDeleteAdmin": "Czy na pewno chcesz usunąć tego administratora?",
  "areYouSureDiscardSimulation": "Czy na pewno chcesz odrzucić zmiany dokonane w trybie symulacji?",
  "areYouSurePublishSimulation": "Czy na pewno chcesz opublikować zmiany dokonane w trybie symulacji?",
  "areYouSureReset": "Czy na pewno chcesz zresetować? Spowoduje to usunięcie wszystkich węzłów.",
  "areYouSureUnplanAllFutureActions": "Czy na pewno chcesz anulować plan wszystkich przyszłych działań w tym projekcie?",
  "areYouSureWantToExit": "Czy na pewno chcesz wyjść?",
  "arrival": "Przyjazd",
  "assetAddedOrRemoved": "Zasób został dodany lub usunięty",
  "assetRequirementsForAsset": "Wymagania Zasobów dla Zasobu {{index}}",
  "assets": "Zasoby",
  "atLeast1LowercaseLetter": "co najmniej 1 mała litera",
  "atLeast1Number": "co najmniej 1 cyfra",
  "atLeast1UppercaseLetter": "co najmniej 1 wielka litera",
  "atLeast8Characters": "co najmniej 8 znaków",
  "automaticImportConversionSheet": "Automatyczny Arkusz Konwersji {{type}}",
  "automaticSheetConfiguration": "Automatyczna Konfiguracja Arkusza",
  "availability": "Dostępność",
  "availableTimeOneWeek": "Dostępny czas w ciągu tygodnia: ",
  "avgAnalysisDuration": "Średni czas analizy: ",
  "avgSampleBatchInterval": "Średni interwał partii próbek: ",
  "avgSamplesAllocated": "Średnia liczba przydzielonych próbek: ",
  "backlog": "Zaległy",
  "booked": "Zarezerwowany",
  "bookedBy": "Zarezerwowany przez",
  "byCompetenceGroup": "Według Grupy Kompetencji",
  "byDeadline": "Według Terminu",
  "byGroup": "Według Grupy",
  "byText": "Według Tekstu",
  "canBePerformedAnywhere": "Może być wykonane gdziekolwiek",
  "canOnlyBePerformedOnSite": "Może być wykonane tylko na miejscu",
  "cancel": "Anuluj",
  "cancelChanges": "Anuluj Zmiany",
  "cannotUnlockStartedTasks": "Nie możesz odblokować tego, ponieważ jedno lub więcej zadań jest rozpoczęte/wznowione/zakończone",
  "changeLogs": "Dzienniki Zmian",
  "changesHaveBeenMade": "Dokonano zmian, przeładuj, aby uzyskać nowe dane",
  "chatbotGreeting": "Cześć, jestem Twoim chatbotem AI i specjalizuję się w dokumentacji pomocy Plannertech i Librarian oraz w repozytoriach danych, które zaimportowałeś.\nMożesz też zawsze skontaktować się z naszym zespołem wsparcia pod adresem pt@arnvind.com w godzinach 9-16 CET.\nJak mogę Ci pomóc? :-)",
  "chatbotName": "Nazwa Chatbota",
  "chatbotPlaceholder": "Wpisz krótki opis zachowania chatbota.",
  "chatbots": "Chatboty",
  "chattingWith": "Rozmowa z {{name}}",
  "chooseAction": "Wybierz Działanie",
  "chooseTask": "Wybierz Zadanie",
  "chooseWhatToAdd": "Wybierz, co chcesz dodać",
  "cleanUp": "Wyczyść",
  "clear": "Wyczyść",
  "clearConversation": "Wyczyść rozmowę",
  "clearDates": "Wyczyść Daty",
  "clearTable": "Wyczyść Tabelę",
  "clickToSelectOtherFiles": "Kliknij, aby wybrać inne pliki",
  "close": "Zamknij",
  "closeMessage": "zamknij wiadomość",
  "closePanel": "Zamknij panel",
  "collaborator": "Współpracownik",
  "collaborators": "Współpracownicy",
  "domain": "Domena",
  "color": "Kolor",
  "columnName": "Nazwa Kolumny",
  "companyWideChatbot": "Chatbot dla całej firmy",
  "competenceAndInstrumentConstraints": "Ograniczenia Kompetencji i Instrumentu",
  "competenceGroup": "Grupa Kompetencji",
  "competenceGroupNameExists": "Grupa kompetencji o tej nazwie już istnieje",
  "competenceGroups": "Grupy Kompetencji",
  "competenceGroupsColon": "Grupy Kompetencji: ",
  "configuration": "Konfiguracja",
  "confirm": "Potwierdź",
  "confirmArchivalOfMember": "Potwierdź archiwizację członka: {{initials}}",
  "confirmClearTable": "Czy na pewno chcesz wyczyścić tabelę?",
  "confirmDeleteAllData": "Potwierdzenie spowoduje usunięcie wszystkich danych {{type}}. Nie ma możliwości wycofania, nawet w Trybie Symulacji.",
  "confirmDeleteAllUnplannedProjects": "Potwierdzenie spowoduje usunięcie wszystkich projektów, które nie mają umieszczonych działań na planie",
  "confirmDeleteAllUnplannedSamples": "Potwierdzenie spowoduje usunięcie wszystkich próbek, które nie mają umieszczonych działań na planie",
  "confirmDeleteCompetenceGroup": "Potwierdź usunięcie grupy kompetencji:",
  "confirmDeleteInstrument": "Czy na pewno chcesz usunąć instrument: {{name}}?",
  "confirmDeleteMaintenance": "Czy na pewno chcesz usunąć tę konserwację?",
  "confirmDeleteSample": "Czy na pewno chcesz usunąć tę niezaplanowaną próbkę?",
  "confirmDeleteSampleInfo": "Potwierdzenie spowoduje trwałe usunięcie wybranej próbki",
  "confirmDeletion": "Potwierdź usunięcie",
  "confirmFailSamples": "Czy na pewno chcesz oznaczyć wybrane próbki jako nieudane?",
  "confirmFailSamplesInfo": "Potwierdzenie spowoduje oznaczenie wybranych próbek jako nieudanych. Duplikat zostanie umieszczony w menu niezaplanowanych analiz",
  "confirmFailSamplesQuestion": "Czy na pewno chcesz oznaczyć wybrane próbki jako nieudane?",
  "confirmShowPlannedSamplesInfo": "Potwierdzenie spowoduje wyświetlenie zaplanowanych próbek",
  "confirmShowPlannedSamplesQuestion": "Czy na pewno chcesz wyświetlić zaplanowane próbki?",
  "confirmSortByTime": "Czy na pewno chcesz sortować po czasie",
  "confirmUnplanAllFutureActions": "Czy na pewno chcesz anulować plan wszystkich przyszłych działań w tym projekcie?",
  "confirmUnplanAllQuestion": "Czy na pewno chcesz anulować plan wszystkich {{itemType}}?",
  "confirmUnplanSamplesInfo": "Potwierdzenie spowoduje anulowanie planu dla wybranych próbek. Zostaną umieszczone w menu niezaplanowanych analiz",
  "confirmUnplanSamplesQuestion": "Czy na pewno chcesz anulować plan dla wybranych próbek?",
  "connectionCalculatedInWorkdays": "Połączenie obliczane w dniach roboczych",
  "connectionCount": "Liczba Połączeń",
  "connections": "Połączenia",
  "connectionsAdvancedWarning": "(Korzystanie z połączeń z terminem lub najwcześniejszym startem dla działań jest dla zaawansowanych użytkowników)",
  "connectionsPerformersOnly": "Połączenia dotyczą tylko wykonawców - nie wpływają na alokację zasobów",
  "contactArnvindSupport": "Skontaktuj się z pomocą Arnvind na pt@arnvind.com",
  "conversionSheet": "Arkusz Konwersji",
  "copyToClipboard": "skopiuj do schowka",
  "country": "Kraj",
  "create": "Utwórz",
  "createANewColumn": "Utwórz nową Kolumnę",
  "createAction": "Utwórz Działanie",
  "createChatbot": "Utwórz chatbota",
  "createEditChatbots": "Utwórz/edytuj chatboty",
  "createEditRepositories": "Utwórz/edytuj repozytoria",
  "createNewColumn": "Utwórz nową Kolumnę",
  "createNewProject": "Utwórz Nowy Projekt",
  "createSingleAction": "Utwórz Jedno Działanie",
  "createStage": "Utwórz Etap",
  "createStandardAction": "Utwórz Standardowe Działanie",
  "currentlyProcessingRepository": "Trwa przetwarzanie tego repozytorium",
  "daily": "Codziennie",
  "date": "Data",
  "dateUnavailable": "Data Niedostępna",
  "day": "dzień",
  "dayS": "dzień/dni",
  "days": "dzień/dni",
  "daysBeforeExpirationWarning": "Dni przed wygaśnięciem, aby wyświetlić ostrzeżenie",
  "daysBetweenRecurrences": "Dni Między Powtórzeniami",
  "deadline": "Termin",
  "deadlineColon": "Termin: ",
  "deadlineDate": "Data terminu",
  "deadlineMustBeLaterThanEarliestStart": "Termin musi być późniejszy lub równy najwcześniejszemu startowi",
  "deadlineTime": "Czas Terminu",
  "defaultChatbot": "Domyślny chatbot",
  "delete": "Usuń",
  "deleteAllTypeTestData": "Usuń wszystkie {{type}} Dane Testowe",
  "deleteAllUnplannedProjects": "Usuń Wszystkie Niezaplanowane Projekty",
  "deleteAllUnplannedSamples": "Usuń Wszystkie Niezaplanowane Próbki",
  "deleteColumn": "Usuń Kolumnę",
  "deleteCompetenceGroup": "Usuń Grupę Kompetencji",
  "deleteCompetenceGroupWarning": "Usunięcie tego spowoduje brak Grupy Kompetencji dla zadań w następujących analizach. Upewnij się, że masz zamiennika przed usunięciem.",
  "deleteConstraint": "Usuń ograniczenie",
  "deleteData": "Usuń Dane",
  "deleteInstrument": "Usuń Instrument",
  "deleteInstrumentWarning": "Zostanie również usunięty dla innych zespołów na tej lokalizacji.",
  "deleteProjects": "Usuń Projekty",
  "deleteSample": "Usuń Próbkę",
  "deleteSamples": "Usuń Próbki",
  "deleteThisRow": "Usuń ten wiersz",
  "description": "Opis",
  "designTool": "Narzędzie Projektowania",
  "done": "Gotowe",
  "draft": "wersja robocza",
  "dragAndDropFiles": "Przeciągnij i upuść pliki tutaj, lub kliknij, aby wybrać pliki",
  "dragAndDropFolders": "Przeciągnij i upuść foldery tutaj, lub kliknij, aby wybrać określone pliki",
  "dropFilesHere": "Upuść pliki tutaj",
  "dropFoldersHere": "Upuść foldery tutaj...",
  "duplicate": "Duplikuj",
  "durationHHMM": "Czas Trwania (HH:MM)",
  "earliestStart": "Najwcześniejszy Start",
  "edit": "Edytuj",
  "editAction": "Edytuj Działanie",
  "editAdmin": "Edytuj Administratora",
  "editAnalysisGroup": "Edytuj grupę analiz",
  "editAnalysisTask": "Edytuj zadanie Analizy",
  "editChatbot": "Edytuj chatbota",
  "editCompetenceGroup": "Edytuj Grupę Kompetencji",
  "editConnectionFromTo": "Edytuj połączenie z {{from}} do {{to}}",
  "editConversation": "Edytuj Rozmowę",
  "editGroup": "Edytuj grupę",
  "editInstrument": "Edytuj Instrument",
  "editItem": "Edytuj {{item}}",
  "editLocationName": "Edytuj nazwę lokalizacji",
  "editMaintenanceFor": "Edytuj {{name}} dla {{assetName}}",
  "editMember": "Edytuj członka",
  "editOffsite": "Edytuj OFFSITE",
  "editProject": "Edytuj Projekt",
  "editProjectGroup": "Edytuj grupę projektów",
  "editProjectTemplate": "Edytuj Szablon Projektu",
  "editProjectTemplateDraft": "Edytuj Szablon Projektu WERSJA ROBOCZA",
  "editRepository": "Edytuj repozytorium",
  "editSampleName": "Edytuj próbkę: {{name}}",
  "editSheet": "Edytuj Arkusz {{name}}",
  "editStandardAction": "Edytuj Standardowe Działanie",
  "editTask": "Edytuj zadanie",
  "editTeam": "Edytuj zespół",
  "edited": "Edytowane",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "E-mail nie może zawierać '..'",
  "emailLabel": "E-mail",
  "endDate": "Data końcowa",
  "enterSimulationMode": "Wejdź w Tryb Symulacji",
  "errors": "Błędy",
  "errorsProcessingRepository": "Podczas przetwarzania tego repozytorium wystąpiły błędy",
  "estimatedWorkloadOneWeek": "Szacunkowe obciążenie pracy w ciągu tygodnia: ",
  "exclusive": "Wyłączne",
  "exclusiveSampleIndicator": "* Wskazuje próbkę wyłączną",
  "exitSimulation": "WYJŚCIE Z SYMULACJI",
  "exitSimulationMode": "Wyjdź z trybu symulacji",
  "expand": "Rozwiń",
  "exportToExcel": "Eksportuj do Excela",
  "fail": "Nieudane",
  "failSample": "Oznacz Próbkę jako Nieudaną",
  "failSelected": "Oznacz Wybrane jako Nieudane",
  "failedLoading": "Błąd ładowania: {{members}}",
  "failedToCreateMaintenance": "Nie udało się utworzyć konserwacji \"{{name}}\"",
  "failedToDeleteMaintenance": "Nie udało się usunąć konserwacji \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Nie udało się oznaczyć konserwacji \"{{name}}\" jako ukończoną",
  "failedToUpdateMaintenance": "Nie udało się zaktualizować konserwacji \"{{name}}\"",
  "failedUploads": "Nieudane Przesyłania",
  "fileUpload": "Przesyłanie Pliku",
  "fileUploadError": "Podczas przesyłania pliku wystąpił błąd",
  "filenameLabel": "Nazwa pliku: ",
  "filesUploadedSuccessfully": "Pliki zostały przesłane pomyślnie",
  "fillIn": "Uzupełnij",
  "fillInIgnoreOverbooking": "Uzupełnij Ignorując Overbooking",
  "filter": "Filtr",
  "filterByName": "Filtruj Według Nazwy",
  "filterBySampleName": "Filtruj Według Nazwy Próbki",
  "filterBySampleProductName": "Filtruj Według Nazwy Próbki/Produktu",
  "filterByText": "Filtruj Według Tekstu",
  "finished": "Zakończone",
  "flag": "Flaga",
  "flagSample": "Oznacz Próbkę Flagą",
  "followingErrorsWhileImporting": "Następujące błędy podczas importu:",
  "free": "Wolne",
  "from": "Z",
  "fromDate": "Z daty",
  "fromTime": "Od godziny (HH:MM)",
  "fromTimeHH": "Od godziny (HH)",
  "fromTimeHHMM": "Od godziny (HH:MM)",
  "futureAnalysisTaskCantBe": "Przyszłe zadanie Analizy nie może być {{state}}",
  "generate": "Generuj",
  "globalChatbot": "Globalny chatbot",
  "goBack": "Wróć",
  "goBackToChat": "Wróć do czatu",
  "greyTaskTimePercentage": "Procent czasu szarego zadania w stosunku do czasu całkowitego (G2T)",
  "groupMembers": "Członkowie Grupy",
  "groupName": "Nazwa Grupy",
  "help": "Pomoc",
  "helpBackToApp": "Wróć do aplikacji",
  "helpHome": "Strona główna pomocy",
  "helpPageNotFound": "Nie znaleziono strony pomocy",
  "helpSearch": "Szukaj w pomocy",
  "helpAppTitle": "Pomoc Plannertech",
  "hidden": "Ukryte",
  "hideMore": "Ukryj więcej",
  "highestPriority": "1 to najwyższy priorytet",
  "history": "Historia",
  "home": "Strona startowa",
  "hour": "godzina",
  "iCalendarOutlookIntegration": "Integracja iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignoruj Wszystkie Szare Zadania",
  "ignoredByIap": "Ignorowane przez IAP",
  "includingToday": "Włączając dzisiaj",
  "importedTask": "Zaimportowane zadanie",
  "busyOnAnotherTeam": "Zajęty w innym zespole",
  "includeDoneSamples": "Uwzględnij gotowe próbki",
  "includeOverdue": "Uwzględnij Zaległe",
  "includeToday": "Uwzględnij Dzisiaj",
  "iapIncludeTodayWarningIAP": "Ostrzeżenie IAP i Include Today - zadania zaplanowane wcześniej dzisiaj mogą być również przenoszone, jeśli nie są zablokowane!",
  "iapIncludeTodayWarningFillIn": "Ostrzeżenie Fill In i Include Today - zadania zaplanowane wcześniej dzisiaj mogą również otrzymać nowe przydzielone próbki!",
  "initials": "Inicjały",
  "inputLastMonth": "Wprowadź Ostatni Miesiąc",
  "inputThisMonth": "Wprowadź Ten Miesiąc",
  "instrument": "Instrument",
  "instrumentConstraints": "Ograniczenia Instrumentu",
  "instrumentLog": "Dziennik Instrumentu",
  "instrumentName": "Nazwa Instrumentu",
  "instrumentOffset": "Przesunięcie Instrumentu (HH:MM)",
  "instrumentOverbooking": "Overbooking Instrumentu",
  "instrumentPerSampleDuration": "Czas Instrumentu na próbkę (HH:MM:SS)",
  "instrumentSetup": "Konfiguracja Instrumentu {{name}}",
  "instrumentSetuptime": "Czas Konfiguracji Instrumentu (HH:MM)",
  "instrumentTime": "Czas Instrumentu",
  "instrumentView": "Widok Instrumentu",
  "instruments": "Instrumenty",
  "instrumentsWithExpiredMaintenance": "Istnieją instrumenty z wygasłą konserwacją",
  "instrumentsWithMaintenanceReminders": "Istnieją instrumenty z przypomnieniami konserwacji",
  "integration": "Integracja",
  "invalidDate": "Niepoprawna Data",
  "invalidOutlookLink": "Niepoprawny link iCalendar / Outlook",
  "isInSimulationMode": "{{initials}} jest w trybie symulacji",
  "isSimulating": "{{initials}} symuluje...",
  "keepExistingConnections": "Zachowaj istniejące połączenia",
  "labelAlreadyLoaded": "Już załadowane: {{count}}",
  "labelCreated": "Utworzono: {{count}}",
  "labelDeleted": "Usunięto: {{count}}",
  "labelDeletedOrFinished": "Usunięto lub oznaczono jako ukończone: {{count}}",
  "labelDoneDeleted": "Gotowe/Usunięte: {{count}}",
  "labelUpdatedInformation": "Zaktualizowane informacje: {{count}}",
  "lastErrorLog": "Ostatni Dziennik Błędów",
  "lastWeek": "Ostatni Tydzień",
  "latestArrival": "Najpóźniejszy Przyjazd",
  "leadTimesInWorkDays": "Czasy Prowadzenia w Dniach Roboczych",
  "leaveEmptyIfNotUsed": "(pozostaw puste, jeśli nie jest używane)",
  "leaveEmptyIfNotUsedDefault": "(pozostaw puste, jeśli nie jest używane, domyślnie={{defaultValue}})",
  "loadFromTemplate": "Załaduj z szablonu",
  "loading": "ŁADOWANIE",
  "loadingEllipsis": "Ładowanie...",
  "loadingSamples": "Ładowanie próbek",
  "loadingSheet": "Ładowanie arkusza",
  "loadingSheets": "Ładowanie arkuszy",
  "location": "Lokalizacja",
  "locationColon": "Lokalizacja: {{name}}",
  "locationName": "Nazwa Lokalizacji",
  "lockItemType": "Zablokuj {{itemType}}",
  "lockSamples": "Zablokuj próbki",
  "lockUnlockSamplesLabel": "Zablokuj/Odblokuj próbki:",
  "locks": "Blokady",
  "locksAllFutureAnalysisTasks": "Blokuje wszystkie przyszłe zaplanowane zadania analizy",
  "locksAllFutureProjectActions": "Blokuje wszystkie przyszłe zaplanowane działania projektu",
  "login": "Logowanie",
  "logout": "Wyloguj",
  "maintenanceCreatedSuccessfully": "Konserwacja \"{{name}}\" została utworzona pomyślnie",
  "maintenanceDeletedSuccessfully": "Konserwacja \"{{name}}\" została usunięta pomyślnie",
  "maintenanceExpired": "Konserwacja wygasła",
  "maintenanceExpiresInDays": "Konserwacja wygasa za mniej niż {{days}} dni",
  "maintenanceMarkedAsCompleted": "Konserwacja \"{{name}}\" została oznaczona jako ukończona",
  "maintenanceName": "Nazwa konserwacji",
  "maintenanceUpdatedSuccessfully": "Konserwacja \"{{name}}\" została zaktualizowana pomyślnie",
  "mandatoryIfRecurrenceUsed": "(obowiązkowe, jeśli używane jest powtórzenie)",
  "manualSample": "Ręczna próbka",
  "manualSheetConfiguration": "Ręczna Konfiguracja Arkusza",
  "markAsDone": "Oznacz jako gotowe",
  "maxSampleCount": "Maksymalna Liczba Próbek",
  "maxSampleCountLabel": "Maks. liczba próbek: ",
  "maxTimeBetweenActions": "Maksymalny czas między działaniami (DD:HH:MM)",
  "maxTimeBetweenTasks": "Maksymalny czas między zadaniami (DD:HH:MM)",
  "member": "Członek",
  "memberHasEnabledICalendarOutlookIntegration": "Członek włączył integrację iCalendar / Outlook",
  "memberHasEnabledOutlook": "Członek włączył integrację iCalendar / Outlook",
  "memberPermissions": "Uprawnienia Członka",
  "memberPlan": "Plan Członka",
  "memberTime": "Czas Członka",
  "membersGoDirectlyToMemberPlan": "Członkowie idą bezpośrednio do planu członka",
  "message": "Wiadomość",
  "metric": "Metryka",
  "minSampleCount": "Minimalna Liczba Próbek",
  "minSampleMustBeLowerThanMax": "Minimalna liczba próbek musi być niższa niż maksymalna liczba próbek",
  "minTimeBetweenActions": "Minimalny czas między działaniami (DD:HH:MM)",
  "minTimeBetweenTasks": "Minimalny czas między zadaniami (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Minimalny czas między musi być mniejszy niż maksymalny czas między",
  "minimumDuration": "Minimalna Czas Trwania: {{time}}",
  "minute": "minuta",
  "missingPasswordRequirements": "Brakuje wymagań hasła: {{requirements}}",
  "months": "Miesiące",
  "movedBy": "Przeniesiony Przez",
  "movedFrom": "Przeniesiony Z",
  "movedTo": "Przeniesiony Do",
  "mustBeIcsLink": "Musi być linkiem .ics",
  "name": "Nazwa",
  "namePerformer": "Wykonawca {{name}}",
  "nameTooLongTitle": "Nazwa zbyt długa (maksymalnie 100 znaków)",
  "newAnalysisTaskBundle": "Nowy Pakiet Zadań Analizy",
  "newChat": "Nowy czat",
  "newInstrument": "Nowy Instrument",
  "newProject": "Nowy Projekt",
  "newProjectTemplateDraft": "Nowy Szablon Projektu WERSJA ROBOCZA",
  "newStart": "Nowy Start",
  "nextDay": "Następny Dzień",
  "nextWeek": "Następny Tydzień",
  "no": "Nie",
  "noAnalysesForProduct": "Nie znaleziono analiz dla tego produktu.",
  "noAssetsFound": "Nie znaleziono zasobów",
  "noChanges": "Brak zmian",
  "noChatbotSelected": "Nie wybrano chatbota",
  "noDataFound": "Nie znaleziono danych",
  "noErrorsToDisplay": "Brak błędów do wyświetlenia.",
  "noGroup": "Brak grupy",
  "noMembersLoaded": "Nie załadowano żadnych członków.",
  "noOfRecurrences": "Liczba Powtórzeń",
  "noReferencesAvailable": "Brak dostępnych odnośników.",
  "noSamples": "Brak próbek",
  "noSamplesAvailable": "Brak dostępnych próbek",
  "noSearchResults": "Brak wyników wyszukiwania",
  "noTimeLimitUnlessSpecified": "Brak limitu czasu, chyba że podano",
  "none": "Brak",
  "default": "Domyślne",
  "notAvailable": "N/D",
  "notEnoughRoomForDuration": "Niewystarczająca ilość miejsca dla czasu trwania",
  "notStarted": "Nie Rozpoczęte",
  "numberOfObservations": "Liczba Obserwacji",
  "numberOfRecurrences": "Liczba powtórzeń",
  "numericInputBetweenTimeRange": "Proszę podać wartość liczbową między 00:00 i 23:59",
  "offsiteCalendar": "Kalendarz OFFSITE",
  "ok": "Ok",
  "oldInstrument": "Stary Instrument",
  "oldStart": "Stary Start",
  "onlyAdvancedUsersInfo": "Tylko zaawansowani użytkownicy używają zarówno najwcześniejszego startu, jak i połączeń",
  "onsite": "Na miejscu",
  "openReferences": "Otwórz Odnośniki",
  "operationalGreyTaskTimePercentage": "Procent czasu operacyjnego szarego zadania w stosunku do czasu całkowitego (OG2T)",
  "operationalTask": "Zadanie Operacyjne",
  "otherPlannerSimulating": "{{initials}} jest w trybie symulacji",
  "outlookLinkLabel": "Link iCalendar / Outlook",
  "outputLastMonth": "Wyjście Ostatni Miesiąc",
  "outputThisMonth": "Wyjście Ten Miesiąc",
  "parentColumn": "Kolumna Nadrzędna",
  "password": "Hasło",
  "paused": "Wstrzymane",
  "peopleSetup": "Konfiguracja Osób",
  "perSampleDuration": "Czas na próbkę (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Czas na Próbkę dla Konfiguracji Osób",
  "performerConstraintsCount": "Liczba Ograniczeń Wykonawcy",
  "performerConstraintsLabel": "Ograniczenia Wykonawcy",
  "permanentApiToken": "Stały token API",
  "permanentApiTokenDescription": "To jest stały token API, który umożliwia dostęp do Twojego zespołu za pośrednictwem naszego API. Skopiuj i przechowuj go w bezpiecznym miejscu.",
  "pinConversation": "Przypnij rozmowę",
  "planned": "Zaplanowane",
  "planner": "Planista",
  "plannertechLanguage": "Język Plannertech",
  "plannertechVariable": "Zmienna Plannertech",
  "pleaseChooseColor": "Proszę wybrać Kolor dla analizy",
  "pleaseFillOutAnalysisName": "Proszę wypełnić Nazwę Analizy",
  "pleaseFillOutRequiredTaskParams": "Proszę wypełnić wymagane parametry zadania",
  "pleaseGiveEmptyOrFullInput": "Proszę podać puste lub pełne dane",
  "pleaseGiveNumericInput": "Proszę podać wartość liczbową",
  "pleaseInputValidDate": "Proszę podać poprawną datę",
  "pleaseSelectAtLeastOneItem": "Proszę wybrać co najmniej jeden element",
  "pleaseSelectColor": "Proszę wybrać kolor",
  "pleaseSelectFirstDay": "Proszę wybrać pierwszy dzień.",
  "pleaseSelectLastDay": "Proszę wybrać ostatni dzień.",
  "pleaseSelectTimezone": "Proszę wybrać strefę czasową",
  "previousDay": "Poprzedni Dzień",
  "primary": "Podstawowy",
  "primaryInstrument": "Instrument Podstawowy",
  "prioritizeByDeadline": "Priorytetyzuj IAP Według Terminu",
  "prioritizeByPriority": "Priorytetyzuj IAP Według Numeru Priorytetu",
  "priority": "Priorytet",
  "priorityHigh": "(Wysoki)",
  "priorityLow": "(Niski)",
  "priorityMedium": "(Średni)",
  "process": "Proces",
  "processed": "Przetworzony",
  "processing": "Przetwarzanie...",
  "processingInProgress": "Przetwarzanie",
  "productName": "Nazwa Produktu",
  "project": "Projekt",
  "projectActions": "działania projektu",
  "projectBatchNumber": "Numer Partii Projektu",
  "projectDeadline": "Termin Projektu",
  "projectDescription": "Opis Projektu",
  "projectEarliestStart": "Najwcześniejszy Start Projektu",
  "projectGroup": "Grupa projektów",
  "projectGroupName": "Nazwa Grupy Projektów",
  "projectImport": "Import Projektu",
  "projectImportVariable": "Zmienna Importu Projektu",
  "projectMaterialDescription": "Opis Materiału Projektu",
  "projectMaterialNumber": "Numer Materiału Projektu",
  "projectName": "Nazwa Projektu",
  "projectPriority": "Priorytet Projektu",
  "projectReleaseDate": "Data Wydania Projektu",
  "projectSupplierName": "Nazwa Dostawcy Projektu",
  "projectSupplierNumber": "Numer Dostawcy Projektu",
  "projectTemplate": "szablon projektu",
  "projectTemplates": "Szablony Projektów",
  "projectTimePercentage": "Procent czasu projektu w stosunku do czasu całkowitego (P2T)",
  "projectView": "Widok Projektu",
  "projects": "Projekty",
  "projectsAndActions": "Projekty i Działania",
  "promptPrefix": "Prefiks promptu",
  "promptTooLongTitle": "Prompt jest zbyt długi (maksymalnie 1200 znaków)",
  "publish": "OPUBLIKUJ",
  "publishSimulationChanges": "Opublikuj zmiany z trybu symulacji",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "Librarian QC 3.8",
  "recur": "Powtórz",
  "recurEvery": "Powtórz co",
  "recurrence": "Powtórzenie",
  "reduce": "Zmniejsz",
  "references": "Odnośniki",
  "rejectedFileTypes": "Odrzucone Typy Plików",
  "rejectedFilesIncompatible": "Następujące pliki zostały odrzucone ze względu na niezgodne formaty",
  "reminderDaysBeforeEndDate": "Przypomnienie (dni przed datą końcową)",
  "remove": "Usuń",
  "removeAnalysisFromProduct": "Usuń {{name}} z tego produktu",
  "removeAsset": "Usuń Zasób",
  "removeEverything": "Usuń wszystko",
  "removeInstrument": "Usuń Instrument",
  "reportGenerator": "Generator Raportów",
  "reports": "Raporty",
  "repositories": "Repozytoria",
  "repositoryCurrentlyProcessing": "Repozytorium jest przetwarzane. Odśwież stronę, aby zobaczyć postęp",
  "repositoryHasUnprocessedFiles": "To repozytorium ma nieprzetworzone pliki",
  "repositoryIsProcessed": "To repozytorium zostało przetworzone",
  "repositoryName": "Nazwa Repozytorium",
  "reset": "Resetuj",
  "role": "Rola",
  "row": "Wiersz",
  "rowNumber": " wiersz {{row}}",
  "runIAP": "Uruchom IAP",
  "runningIAP": "Uruchamianie IAP",
  "sampleAnalysisName": "Nazwa Analizy Próbki",
  "sampleBatchNumber": "Numer Partii Próbki",
  "sampleHighestPriority": "Próbka ma najwyższy priorytet",
  "sampleId": "Identyfikator Próbki",
  "sampleIdWithValue": "Identyfikator Próbki: {{id}}",
  "sampleImport": "Import Próbki",
  "sampleImportVariable": "Zmienna Importu Próbki",
  "sampleInProgressOnDoneAnalysis": "Próbka w trakcie wykonywania na zakończonej analizie",
  "sampleIsDone": "Próbka jest gotowa",
  "sampleLog": "Dziennik Próbki",
  "sampleLowestPriority": "Próbka ma najniższy priorytet",
  "sampleMaterialNumber": "Numer Materiału Próbki",
  "sampleName": "Nazwa Próbki",
  "sampleObservation": "Obserwacja Próbki",
  "sampleObservations": "Obserwacje Próbki",
  "samplePercentage": "Procent próbki",
  "sampleProductDescription": "Opis Produktu Próbki",
  "sampleReceivedDate": "Data Otrzymania Próbki",
  "sampleStatus": "Status Próbki",
  "sampleView": "Widok Próbki",
  "samples": "Próbki",
  "samplesWithName": "Próbki o nazwie {{name}}",
  "samplesWithoutProduct": "Próbki bez produktu",
  "save": "Zapisz",
  "saveAs": "Zapisz Jako",
  "saveAsDraft": "Zapisz jako {{type}} WERSJA ROBOCZA",
  "saveAsNew": "Zapisz jako nowe",
  "saveAsNewAnalysis": "Zapisz jako nową analizę",
  "saveAsNewTemplate": "Zapisz jako nowy szablon",
  "saveAsType": "Zapisz jako {{type}}",
  "scrollToTop": "Przewiń na górę",
  "scrumView": "Widok Scrum",
  "scrumViewOrdering": "Porządek Widoku Scrum",
  "searchBySampleName": "Szukaj po nazwie próbki...",
  "searchCountry": "Szukaj kraju",
  "seats": "Siedzenia",
  "second": "sekunda",
  "secondaryInstrumentMustHaveAllowedInstrument": "Konfiguracja instrumentu wtórnego musi mieć co najmniej jeden dozwolony instrument",
  "selectAll": "Wybierz Wszystkie",
  "selectChatbot": "Wybierz chatbota",
  "selectDefaultChatbot": "Wybierz domyślnego chatbota",
  "selectEntireDay": "Wybierz cały dzień",
  "selectEntireWorkday": "Wybierz cały dzień roboczy",
  "selectLocation": "Wybierz lokalizację...",
  "selectSamples": "Wybierz Próbki",
  "selectState": "Wybierz stan...",
  "selectTimezone": "Wybierz strefę czasową...",
  "selectType": "Wybierz Typ",
  "selectedFilesReadyForSubmit": "Wybrane pliki/foldery gotowe do wysłania:",
  "selectedProduct": "Wybrany Produkt",
  "setPlannedValues": "Ustaw Zaplanowane Wartości",
  "settings": "Ustawienia",
  "settingsForQcLibrarian": "Ustawienia dla Librarian QC",
  "setupTimeForPeopleSetup": "Czas Konfiguracji dla Konfiguracji Osób",
  "setuptime": "Czas Konfiguracji (HH:MM)",
  "sheetName": "Nazwa Arkusza",
  "sheetNameLabel": "Nazwa Arkusza",
  "sheetType": "Typ Arkusza",
  "shouldBeEqualTo": "powinien być równy",
  "shouldNotBeEqualTo": "nie powinien być równy",
  "showAnalyses": "Pokaż Analizy",
  "showErrors": "Pokaż Błędy",
  "showLastErrorLog": "Pokaż ostatni dziennik błędów",
  "showLibrarian": "Pokaż Librarian",
  "showLog": "Pokaż Dziennik",
  "showMore": "Pokaż więcej",
  "showOnPlan": "Pokaż na Planie",
  "showProjects": "Pokaż Projekty",
  "shown": "Widoczne",
  "simulationMode": "Tryb Symulacji",
  "simulationModeLogoutWarning": "Jesteś obecnie w trybie symulacji. Wylogowanie spowoduje odrzucenie zmian!",
  "simulationModeOccupied": "TRYB SYMULACJI ZAJĘTY",
  "simulationModeUpper": "TRYB SYMULACJI",
  "somethingWentWrong": "Coś poszło nie tak",
  "sortByProduct": "Sortuj po produkcie",
  "sortByTime": "Sortuj Po Czasie",
  "sortByTimeDescription": "Porządkuje działania z Backlog i To Do po ich terminach, a Zaplanowane i Zakończone po ich czasie startu",
  "speechToTextLanguage": "Język zamiany mowy na tekst",
  "spreadsheetColumnName": "Nazwa Kolumny Arkusza Kalkulacyjnego",
  "stage": "Etap",
  "standardActions": "Standardowe Działania",
  "start": "Start",
  "startDate": "Data Startu",
  "startDateCheckboxInfo": "Gdy zaznaczony jest termin projektu, termin działania i start działania przesuwają się względem startu projektu",
  "startEndDate": "Data Startu/Koniec",
  "startProcessingInfo": "Spowoduje to rozpoczęcie przetwarzania repozytorium. Może to trwać chwilę w zależności od rozmiaru repozytorium",
  "startRecurrence": "Start Powtórzenia",
  "startTime": "Czas Startu",
  "started": "Rozpoczęte",
  "state": "Stan",
  "status": "Status",
  "submit": "Wyślij",
  "successfullyLoaded": "Pomyślnie załadowane: {{members}}",
  "successfullyUploadedFiles": "Pomyślnie Przesłane Pliki",
  "systemPrompt": "Prompt systemowy",
  "taskBelongsToTeam": "Zadanie należy do zespołu: {{team}}",
  "taskCount": "Liczba Zadań",
  "taskDesignTool": "Narzędzie Projektowania Zadań",
  "taskLog": "Dziennik Zadań",
  "taskName": "Nazwa Zadania",
  "taskPerformerConstraints": "Ograniczenia Wykonawcy Zadań",
  "tasks": "Zadania",
  "team": "Zespół",
  "teamChatbot": "Chatbot Zespołu",
  "teamLabel": "Zespół: {{name}}",
  "teamMember": "Członek Zespołu",
  "teamName": "Nazwa Zespołu",
  "teamPlan": "Plan Zespołu",
  "teamUsageTitle": "Użycie {{name}}",
  "teams": "Zespoły",
  "templateIsDraft": "Ten szablon projektu jest Wersją Roboczą",
  "templateName": "Nazwa Szablonu",
  "theProjectIsDone": "Projekt jest ukończony",
  "timeConstraints": "Ograniczenia Czasu",
  "timeHHMM": "Czas (HH:MM)",
  "timePeriod": "Okres Czasowy",
  "timestamp": "Znacznik Czasu",
  "timezone": "Strefa Czasowa",
  "to": "Do",
  "toConfirmDeletionType": "Aby potwierdzić usunięcie, wpisz {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Aby potwierdzić usunięcie, wpisz {{keyword}} i naciśnij potwierdź. Spowoduje to trwałe usunięcie danych testowych, nawet w trybie symulacji. Nie ma możliwości wycofania.",
  "toConfirmDeletionTypeKeyword": "Aby potwierdzić usunięcie, wpisz {{keyword}} i naciśnij potwierdź",
  "toDate": "Do daty",
  "toDo": "Do Zrobienia",
  "toTime": "Do godziny (HH:MM)",
  "toTimeHH": "Do godziny (HH)",
  "toTimeHHMM": "Do godziny (HH:MM)",
  "today": "Dzisiaj",
  "tokens": "Tokeny",
  "total": "Razem",
  "normalSeats": "Normalne",
  "tryReloadingOrContactSupport": "Spróbuj przeładować lub skontaktuj się z pomocą, jeśli problem będzie się powtarzać!",
  "type": "Typ",
  "typeBeforeConfirming": "wpisz {{keyword}} przed potwierdzeniem",
  "typeOrSelect": "Wpisz lub wybierz...",
  "typeYourMessage": "Wpisz swoją wiadomość...",
  "unassignedSamples": "Nieprzydzielone próbki",
  "unassignedSamplesFor": "Nieprzydzielone próbki dla \"{{name}}\"",
  "unflag": "Usuń Flagę",
  "unflagSample": "Usuń Flagę z Próbki",
  "unlockItemType": "Odblokuj {{itemType}}",
  "unlockSamples": "Odblokuj próbki",
  "unlocks": "Odblokowania",
  "unlocksAllFutureAnalysisTasks": "Odblokowuje wszystkie przyszłe zaplanowane zadania analizy",
  "unlocksAllFutureProjectActions": "Odblokowuje wszystkie przyszłe zaplanowane działania projektu",
  "unnamed": "bez nazwy",
  "unpinConversation": "Odepnij rozmowę",
  "unplan": "Usuń z planu",
  "unplanAnalysis": "Usuń analizę z planu",
  "unplanItemType": "Usuń {{itemType}} z planu",
  "unplanSample": "Usuń próbkę z planu",
  "unplanSelected": "Usuń wybrane z planu",
  "unplanned": "Niezaplanowane",
  "unplannedProjects": "Niezaplanowane Projekty",
  "unsavedChangesIn": "Istnieją niezapisane zmiany w:",
  "updateIntegration": "Zaktualizuj Integrację",
  "updatedIcalOutlook": "Zaktualizowano iCalendar / Outlook!",
  "uploadAborted": "Przesyłanie przerwane!",
  "uploadComplete": "Przesyłanie ukończone!",
  "uploadFailedForFile": "Przesyłanie nie powiodło się dla pliku: {{path}}",
  "uploadFinished": "Przesyłanie Zakończone!",
  "uploadTo": "Prześlij do {{name}}",
  "usage": "Użycie",
  "used": "Używane",
  "usedAssets": "Używane Zasoby",
  "usedInstrument": "Używany Instrument",
  "usedInstruments": "Używane Instrumenty",
  "username": "Nazwa Użytkownika",
  "value": "Wartość",
  "view": "Widok",
  "viewAllAnalysesForProduct": "Przeglądaj wszystkie analizy dla tego produktu",
  "viewAnalysisSamples": "Przeglądaj Próbki Analizy",
  "viewCompact": "Wyświetl Kompaktowo",
  "viewNormal": "Wyświetl Normalnie",
  "weekNumber": "Tydzień {{week}}",
  "weekView": "Widok Tygodnia",
  "dayView": "Widok Dnia",
  "weekendView": "Widok Weekendu",
  "screen": "Ekran",
  "clickToSortBy": "Kliknij, aby sortować po {{column}}",
  "fileChangedPleaseReselect": "{{file}} zmienił się. Proszę ponownie wybrać plik",
  "contentTooWideZoomOut": "Zawartość jest zbyt szeroka dla ekranu. Aby uzyskać lepsze wrażenia, pomniejsz ({{key}} +/-)",
  "week": "Tydzień",
  "weekly": "Tygodniowo",
  "weeks": "tydzień/tygodni",
  "withConnections": "z połączeniami",
  "workHours": "Godziny Pracy",
  "workWeek": "Tydzień Pracy",
  "years": "Lata",
  "yes": "Tak",
  "youAreInSimulationMode": "Jesteś w trybie symulacji",
  "zeroHours": "0 godzin",
  "addCustomer": "Dodaj klienta",
  "addGlobalChatbot": "Dodaj globalny chatbot",
  "addGlobalRepository": "Dodaj globalne repozytorium",
  "apiKey": "Klucz API",
  "authenticationCode": "Kod Autentykacji",
  "authenticationCodeSentInfo": "Wysłaliśmy kod autentykacji na Twój e-mail. Proszę wpisz go powyżej przed logowaniem",
  "chatbotPrefix": "Prefiks Chatbota",
  "chatbotSystemPrompt": "Prompt systemowy chatbota",
  "chatbotSystemPrompts": "Prompty systemowe chatbota",
  "citationGuidelines": "Wytyczne Cytowania",
  "configureMember": "Skonfiguruj Członka",
  "createApiKey": "Utwórz klucz API",
  "creatingProject": "Tworzenie Projektu",
  "currentQuestion": "Aktualne Pytanie",
  "customerAdminApiKeyForGlobalRepositories": "Klucz API Administratora Klienta dla Globalnych Repozytoriów",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Usuń klucz API",
  "descriptionPrompt": "Prompt opisu",
  "editGlobalMessage": "Edytuj Wiadomość Globalną",
  "editingProject": "Edycja Projektu",
  "editSystemPrompts": "Edytuj prompty systemowe",
  "filePathPrompt": "Prompt ścieżki pliku",
  "fillingInSamples": "Uzupełnianie próbek",
  "generalPrefix": "Prefiks Ogólny",
  "globalChatbots": "Globalne Chatboty",
  "globalRepositories": "Globalne Repozytoria",
  "hideNextWeek": "Ukryj Następny Tydzień",
  "hideSatSun": "- Sob/Niedz",
  "manageAdmins": "Zarządzaj Administratorami",
  "oneWeek": "1 Tydzień",
  "openMetricsPanel": "Otwórz Panel Metryk/IAP",
  "openTodoList": "Otwórz Listę Zadań",
  "optimizedQuestionPrompt": "Prompt zoptymalizowanego pytania",
  "plannertech": "Plannertech",
  "plannertechSuite": "Pakiet Plannertech",
  "plannertechTeamPlan": "Plan Zespołu Plannertech",
  "previousConversation": "Poprzednia rozmowa",
  "librarianLogoAlt": "Logo Asystenta",
  "qcLibrarianForCompany": "Librarian QC {{company}}",
  "relevantDocumentation": "Istotna dokumentacja",
  "repositoryHasUnprocessedFilesInfo": "To repozytorium zawiera nieprzetworzone pliki",
  "repositoryIsEmpty": "To repozytorium jest puste",
  "repositoryPrefix": "Prefiks Repozytorium",
  "repositoryProcessingInProgressInfo": "Repozytorium jest przetwarzane. Odśwież stronę, aby zobaczyć postęp",
  "sampleAllocation": "Alokacja Próbek",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Siedzenia: {{count}}",
  "excludingToday": "Wyłączając dzisiaj",
  "unplanning": "Usuwanie z planu",
  "activeSeats": "Aktywne siedzenia: {{count}}",
  "totalSeats": "Normalne siedzenia: {{count}}",
  "purchasedSeats": "Zakupione siedzenia: {{count}}",
  "globalMessage": "Wiadomość Globalna",
  "clearGlobalMessageConfirm": "Czy na pewno chcesz wyczyścić wiadomość globalną? Zniknie dla wszystkich użytkowników.",
  "samplesCount": "Próbki: {{count}}",
  "locations": "Lokalizacje",
  "customers": "Klienci",
  "editCustomer": "Edytuj klienta",
  "addCustomerTitle": "Dodaj Klienta",
  "deleteCustomer": "Usuń Klienta",
  "customerName": "Nazwa Klienta",
  "customerStatus": "Status klienta",
  "active": "Aktywny",
  "passive": "Pasywny",
  "allowedDomains": "Dopuszczalne Domeny",
  "allowedPerformers": "Dopuszczalni Wykonawcy",
  "seatsPurchased": "Zakupione siedzenia",
  "customerApiKey": "Klucz API Klienta",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Kontynuuj",
  "showNextWeek": "Pokaż Następny Tydzień",
  "showSatSun": "+ Sob/Niedz",
  "topDescriptionPrompt": "Prompt górnego opisu",
  "twoWeeks": "2 Tygodnie",
  "updateHelpPage": "Zaktualizuj Stronę Pomocy",
  "userAlreadyLoggedInTakeOver": "Użytkownik już zalogowany. Aby przejąć sesję, naciśnij potwierdź",
  "zoomIn": "Powiększ",
  "zoomOut": "Pomniejsz",
  "constraintWarningTitle": "Wystąpi {{count}} ostrzeżenie/ostrzeżenia",
  "assetStatusFree": "Wolne",
  "assetStatusBooked": "Zarezerwowany",
  "dateTo": "do",
  "futureAnalysisTaskCantBeFinished": "Przyszłe zadanie Analizy nie może być ukończone",
  "tableNotFound": "Tabela nie znaleziona",
  "conversionSheetFilename": "Arkusz Konwersji.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Admin Klienta",
  "attachFile": "Dołącz plik",
  "removeFile": "Usuń plik",
  "fileTooLarge": "Plik jest za duży (maks. 10 MB)",
  "tooManyFiles": "Maksymalnie 3 pliki na wiadomość",
  "unsupportedFileType": "Nieobsługiwany typ pliku. Dozwolone: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
